import React from 'react';
import { Box, Typography, Container, TextField, Button } from '@mui/material';
import { motion } from 'framer-motion';

const Contact = () => {
  return (
    // Box component with ID for navigation
    <Box id="contact" sx={{ py: 8, bgcolor: 'background.paper' }}>
      <Container>
        <Typography variant="h2" gutterBottom>
          Contact Me
        </Typography>
        {/* Form container with max width and center alignment */}
        <Box
          component="form"
          sx={{ maxWidth: 600, mx: 'auto' }}
          action="https://formspree.io/f/mrbqlboj"
          method="POST"
        >
          {/* TextField for name input */}
          <TextField
            fullWidth
            label="Name"
            name="name"
            margin="normal"
            required
          />
          {/* TextField for email input */}
          <TextField
            fullWidth
            label="Email"
            name="email"
            margin="normal"
            required
            type="email"
          />
          {/* TextField for message input */}
          <TextField
            fullWidth
            label="Message"
            name="message"
            margin="normal"
            required
            multiline
            rows={4}
          />
          {/* Submit button */}
          <Button
            variant="contained"
            color="primary"
            size="large"
            sx={{ mt: 2 }}
            type="submit"
          >
            Send Message
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Contact;